import { InboxOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row } from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { BiSolidDownload, BiTrash } from "react-icons/bi";
import { inputNome } from "../../GridStyle";
import useAnexo from "./useAnexo";
import Loading from "../../../../components/Loading";
import { IPlanoGovernoAnexo } from "../../interfaces";

interface IModalFormAnexo {
    isEditarAnexo: boolean;
    isModalOpen: boolean;
    handleCancel: () => void;
    handleSave: () => void;
    loadingPage: boolean;
    anexoSelected: IPlanoGovernoAnexo | undefined;
}

export const ModalFormAnexo = ({ isEditarAnexo, isModalOpen, handleCancel, loadingPage, handleSave, anexoSelected }: IModalFormAnexo) => {

    const {
        formAnexo,
        refFormAnexo,
        setIsModalArquivoOpen,
        setArquivoModal,
        fileList,
        onClickBotaoSalvarAnexo,
        handleChangeAnexos,
        removerArquivoAnexo,
        downloadImage,
        isLoadingForm,
        urlPdfAnexo,
        savePdfReceived
    } = useAnexo({ handleSave, isModalOpen, isEditarAnexo, anexoSelected });


    return (
        <Modal
            title={isEditarAnexo ? "Editar Anexo" : "Adicionar Anexo"}
            width={1000}
            footer={[]}
            open={isModalOpen}
            onOk={handleCancel}
            onCancel={handleCancel}
        >

            <Form
                form={formAnexo}
                ref={refFormAnexo}
                name="formNoticias"
                layout="vertical"
                onFinishFailed={() => { }}
            >

                <Loading loading={isLoadingForm}>
                    <Row>
                        <Col hidden {...inputNome}>
                            <Form.Item
                                name="uuid"
                                label="uuid"
                                rules={[
                                    {
                                        required: false,
                                        message: "Por favor preencha o uuid!",
                                    },
                                ]}
                            >
                                <Input placeholder="id" disabled />
                            </Form.Item>
                            <Form.Item name="arquivo" label="arquivo">
                                <Input placeholder="arquivo" disabled />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="nome"
                                label="Nome do arquivo"
                                rules={[
                                    {
                                        required: true,
                                        message: "Por favor preencha o nome!",
                                    },
                                ]}
                            >
                                <Input placeholder="Ex: 1° Execução do Plano de Governo" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                // name="imagensNoticiaItem"
                                label={fileList.length === 0 ? "Arquivo" : ""}
                                rules={
                                    [{
                                        required: true,
                                        message: "Por favor envie um arquivo!",
                                    }]}
                            >
                                {fileList.length === 0 && <Dragger
                                    multiple={false}
                                    maxCount={1}
                                    accept=".pdf"
                                    onChange={handleChangeAnexos}
                                    fileList={fileList}
                                    customRequest={(options) => {
                                        return options.onSuccess && options.onSuccess(options);
                                    }}
                                    name="file"
                                    showUploadList={false}
                                    style={{
                                        marginBottom: 10,
                                    }}
                                >
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                        Clique ou arraste o arquivo para esta
                                        área para fazer upload
                                    </p>
                                </Dragger>}
                                {fileList?.map((file: any, index: any) => (
                                    <div
                                        key={index}
                                        style={{
                                            marginRight: 10,
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            width: '100%',
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                            <h3>{file?.name ? file.name : anexoSelected?.arquivo}</h3>
                                            <div
                                                key={Math.random()}>
                                                <a
                                                    style={{
                                                        padding: 5,
                                                        marginRight: 10
                                                    }}
                                                    onClick={() => file?.name ? downloadImage(
                                                        URL.createObjectURL(
                                                            file?.originFileObj
                                                        )
                                                    ) : savePdfReceived()} download>
                                                    <BiSolidDownload size={25} />
                                                </a>
                                                <span style={{
                                                    padding: 5,
                                                    cursor: 'pointer',
                                                }} onClick={() => {
                                                    removerArquivoAnexo(file, index)
                                                }}><BiTrash color="#FF2929" size={25} />
                                                </span>
                                            </div>
                                        </div>
                                        <embed type="application/pdf" width={'100%'} height={400} src={file?.originFileObj ? URL.createObjectURL(file.originFileObj) : urlPdfAnexo} />
                                    </div>
                                ))}
                            </Form.Item>
                        </Col>
                    </Row>
                </Loading>
                <Row>
                    <Col span={24}>
                        {/* Botões de salvar  */}
                        <Row>
                            <Col span={24} style={{ textAlign: "end" }}>
                                <Button
                                    style={{ marginRight: 10 }}
                                    loading={loadingPage}
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    disabled={loadingPage}
                                    type="primary"
                                    loading={isLoadingForm}
                                    onClick={() => {
                                        onClickBotaoSalvarAnexo()
                                    }
                                    }
                                >
                                    {isEditarAnexo ? "Editar" : "Salvar"}
                                </Button>

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Modal >
    );
}
